import React, { useState, useRef } from 'react';
import styles from '../../styles/LocationInput.module.scss';

interface LocationInputProps {
  onSubmit: (location: string) => void;
}

const LocationInput: React.FC<LocationInputProps> = ({ onSubmit }) => {
  const [location, setLocation] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (location.trim()) {
      onSubmit(location.trim());
      inputRef.current?.blur();
    }
  };

  return (
    <div className={styles['location-input-container']}>
      <h1 className={styles.title}>Thunder Funk!</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles['input-container']}>
          <input
            ref={inputRef}
            type="text"
            placeholder="Enter a location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={styles.input}
          />
          <button type="submit" className={styles.iconButton} aria-label="Submit location">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              xmlns="http://www.w3.org/2000/svg"
            >
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
};

export default LocationInput;
